import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { translate } from '@jsverse/transloco';

import { AppSharedModule } from '../../../../../app-shared.module';
import {
  SENTIMENT_HEX_COLOR_3_SCALE,
  SENTIMENT_HEX_COLOR_5_SCALE,
} from '../../../../collection/components/sentiment-display/sentiment-display.component';

export const SENTIMENT_COLORS = { ...SENTIMENT_HEX_COLOR_3_SCALE, ...SENTIMENT_HEX_COLOR_5_SCALE };

@Component({
  selector: 'app-sentiment-bar',
  imports: [AppSharedModule],
  templateUrl: './sentiment-bar.component.html',
  styleUrl: './sentiment-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SentimentBarComponent {
  sentimentBuckets = input.required<{ [key: string]: number }>();
  precision = input.required<number>();

  sentimentPercentages = computed(() => {
    const total = Object.values(this.sentimentBuckets()).reduce((sum, current) => sum + current, 0);

    if (!total) {
      return [
        {
          bucket: 'neutral',
          tooltip: translate(`project-sentiment-range.polarities.invalid-polarity`),
          color: SENTIMENT_COLORS['neutral'],
          percentage: 100,
        },
      ];
    }

    return this.BUCKET_ORDER.flatMap((bucket) => {
      if (!this.sentimentBuckets()[bucket]) {
        return [];
      }

      const percentage = (this.sentimentBuckets()[bucket] / total) * 100;
      const translatedSentiment = translate(
        `project-sentiment-range.polarities.${bucket.replace(' ', '-')}`
      );

      return [
        {
          bucket,
          tooltip: `${translatedSentiment}: ${this.sentimentBuckets()[bucket]}/${total} (${percentage.toFixed(this.precision())}%)`,
          color: SENTIMENT_COLORS[bucket],
          percentage,
        },
      ];
    });
  });

  readonly BUCKET_ORDER = [
    'very negative',
    'somewhat negative',
    'negative',
    'neutral',
    'somewhat positive',
    'very positive',
    'positive',
  ];
}
